import { ChildrenProps } from '@cotera/client/app/components/utils';
import {
  makeStoreContextHook,
  makeStoreProvider,
  StateSetter,
} from '@cotera/client/app/etc';
import { createContext } from 'react';

type State = {
  history: { children: ChildrenProps['children']; title?: React.ReactNode }[];
};

type Actions = (set: StateSetter<State>) => {
  push(value: {
    title?: React.ReactNode;
    children: ChildrenProps['children'];
  }): void;
  pop(): void;
  resetWith(value: {
    title?: React.ReactNode;
    children: ChildrenProps['children'];
  }): void;
};

const Context = createContext<State>(undefined as any);

const InternalPagerProvider = makeStoreProvider<State, ReturnType<Actions>>(
  Context
);

export const usePagerContext = makeStoreContextHook<State, ReturnType<Actions>>(
  Context
);

const actions: Actions = (set) => ({
  push: (value) => {
    set((state) => {
      return {
        history: [...state.history, value],
      };
    });
  },
  pop: () => {
    set((state) => {
      return {
        history: state.history.slice(0, state.history.length - 1),
      };
    });
  },
  resetWith: (value) => {
    set(() => {
      return {
        history: [value],
      };
    });
  },
});

export const PagerProvider: React.FC<ChildrenProps> = ({ children }) => {
  return (
    <InternalPagerProvider
      state={{
        history: [],
      }}
      actions={actions}
    >
      {children}
    </InternalPagerProvider>
  );
};
